<div class="recent-chat-item" [class.editing]="isEditing()">
  <!-- View Mode: Clickable chat card -->
  @if (!isEditing()) {
    <button
      class="chat-button"
      (click)="chatClick.emit(chat())"
      [attr.aria-label]="getAriaLabel()"
    >
      <div class="chat-content">
        <div class="chat-header">
          <span class="chat-name">{{ getChatDisplayName() }}</span>
          @if (showTimestamp()) {
            <span class="chat-timestamp">{{ formatTimestamp() }}</span>
          }
        </div>
        <div class="chat-meta">
          @if (chat().agentIconUri) {
            <img
              [src]="chat().agentIconUri"
              [alt]="chat().agentName + ' icon'"
              class="agent-icon-small"
            />
          }
          <span class="agent-name">{{ chat().agentName }}</span>
        </div>
      </div>
    </button>

    <div class="chat-actions">
      <button
        class="edit-btn"
        (click)="startEditing($event)"
        [attr.aria-label]="'SESSION.RENAME' | translate"
        [matTooltip]="'SESSION.RENAME' | translate"
        matTooltipPosition="above"
        [matTooltipShowDelay]="200"
      >
        <app-icon name="edit" [size]="16" />
      </button>
      <button
        class="delete-btn"
        (click)="onDelete($event)"
        [attr.aria-label]="'SESSION.DELETE' | translate"
        [matTooltip]="'SESSION.DELETE' | translate"
        matTooltipPosition="above"
        [matTooltipShowDelay]="200"
      >
        <app-icon name="delete" [size]="16" />
      </button>
    </div>
  }

  <!-- Edit Mode: Inline editor with save/cancel (delegated to component) -->
  @if (isEditing()) {
    <app-chat-name-editor
      [name]="getChatDisplayName()"
      [isEditing]="true"
      (save)="saveEdit($event)"
      (cancel)="cancelEdit()"
    />

    <div class="chat-actions">
      <!-- Action buttons will be part of the editor component in edit mode -->
    </div>
  }
</div>
